module.exports = __webpack_public_path__ + "static/media/calendar.c762f766.svg";